import { Alert } from '@mui/material';
import { NOT_AUTHORIZED_MESSAGE } from 'src/constants/errors';
import styleVariables from '../../scss/_variables.scss';
import { PATHS } from 'src/constants/navigateRoutes';
import { Link } from 'react-router-dom';

export const NotAuthorizedCard = () => {
  return (
    <Alert
      sx={{
        marginBottom: '16px',
      }}
      severity="error"
    >
      {NOT_AUTHORIZED_MESSAGE}. You can view all admins in the Users module -{' '}
      <Link
        style={{ color: styleVariables.colorYellow }}
        id="view_admins_not_authorized_message"
        to={PATHS.users}
      >
        Visit Users Module
      </Link>
    </Alert>
  );
};
